import AgencyTransactionList from 'common/pages/agency-transactions/AgencyTransactionList.tsx'

export const AgencyTransactionListAgency = (props: any) => <AgencyTransactionList {...props} />